import { constants } from "../../../constants";

export default class RequestLogin {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.requestLogin();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.SLINGO:
            case constants.GSPOKER:
           // case constants.GSBINGO:
                event["showLogin"] = this._default;
                break;
            case constants.BGS:
                event["notLoggedInError"] = this._default;
                break;
            case constants.RGU:
                event["notLoggedInError"] = this._default;
                break;
            case constants.RAW:
                event["notLoggedInError"] = this._default;
                break;
            case constants.HB:
                event["notLoggedInError"] = this._default;
                break;
            default:
                event["login"] = this._default;
        }

        return event;
    }
}
